import Lottie from 'lottie-react'

import animationData from './assets/S-loader.json'

type Props = {
  dataTestId?: string
}

export const AnimatedLoader = ({ dataTestId }: Props) => (
  <Lottie
    data-testid={dataTestId}
    animationData={animationData}
    loop={true}
    autoplay={true}
    style={{ width: 130, height: 190 }}
  />
)
